export const APP_NAME = 'fuelSaving';
export const FUEL_SAVING_APPLY_SOURCE = 'fuelSavingApply';
export const FUEL_SAVING_APPLY_AND_PRINT_SOURCE = 'fuelSavingApplyAndPrint';
